import { showDialogError, showDialogSuccess} from '../sweealert2';

$(document).ready(function () {
  function calcDiscount() {
    var totalDiscount = _.toNumber($('#total_discount').val()) || 0;
    $.each($('#form-special-discount').find('.discount-fields'), function (idx, $elm) {
      var specialDiscount = _.toNumber(parseInt($($elm).find('.js-special-discount').val().replace(/,/g, ''), 10)) || 0;
      totalDiscount += specialDiscount;
    });

    $(".form-estimate-sheet .nested-fields").filter(":visible").each(function (idx, $parent) {
      const discountElement = $($parent).find(".estimate_sheet_estimate_items_discount input");
      let discount_value = (discountElement.val() != '' && discountElement.val() != undefined) ? discountElement.val().replace(/,/g, '') : 0;
      let discount = _.toNumber(parseInt(discount_value));
      totalDiscount += discount;
    });
    $('#total_discount').val('￥ ' + totalDiscount.toLocaleString('en-US'));
  }

  $(document).on('change', '.est-checked-ordered', function() {
    const $row = $(this).closest('.nested-fields')
    const $elmCostPrice = $row.find('.js-cost-price')
    const isSegmentCostPrice = $elmCostPrice.hasClass('segment-cost-price')

    if (isSegmentCostPrice) return;

    if($(this).is(':checked')) {
      $('#old-cost-price').val($elmCostPrice.val());
      $elmCostPrice.attr('readonly', true).addClass('bg-gray');
            sum_cost_price($(this));
    } else {
      $elmCostPrice.attr('readonly', false).val($('#old-cost-price').val()).removeClass('bg-gray');
    }
  })


  $(document).on('change', '.estimate_sheet_discounts_amount #js-special-discount, .esimate-sheet-page input, .level-select', function(){
    calcDiscount()
    estimateSheetCalcTotal()
  })

  $(document).on('change', '.js-discount', function() {
    calcDiscount()
  })


  // $(document).on('change', '.esimate-sheet-page input', function () {
  //   estimateSheetCalcTotal(false)
  // })

  function estimateSheetCalcTotal(isNewPage = false) {
    const marginNumber = _.defaultTo(_.toNumber($('.margin-number-temp').val()), _.toNumber($('#margin-number-temp').val()));
    let totalSellPrice = 0;
    let totalCost = 0;
    let totalAllDiscount = 0;
    let totalAllDiscountFreeTax = 0;
    let totalGrossProfitSegmented = 0;
    let totalGrossProfit = 0;
    let summaryTotal = 0;
    let freeTaxTotal = 0;

    let taxIncluded = 0;
    let totalSellPriceUnchecked = 0;
    let totalSellPriceChecked = 0;

    let totalOrderValue = calculateOrderTotal();

    const processItem = ($elm, isSellPrice = true) => {
        const getNumericValue = ($el) => {
            const value = $el.val();
            if (value !== undefined) {
                return _.toNumber(value.replace(/,/g, '')) || 0;
            }
            return 0;
        };
        const costPrice = getNumericValue($($elm).find('.js-cost-price'));
        const amount = getNumericValue($($elm).find('.js-amount'));
        const priceDOM = $($elm).find('.js-price');

        let price = !isNewPage ? getNumericValue(priceDOM) : _.toNumber((marginNumber * costPrice).toFixed(2));

        if (isNewPage) {
          priceDOM.val(price).change();
        }

        const discount = getNumericValue($($elm).find('.js-discount'));
        totalAllDiscount += discount;

        calculateOrderItem($elm)
        const sellPrice = getNumericValue(
          $($elm)
            .find('.sell-price')
            .filter(function () {
              const level = $(this).closest('.nested-fields').find('.level-select').val();
              return !level || level.toLowerCase() === 'nil';
            })
        );

        if ($($elm).find('.js-is_freetax').is(':checked')) {
            totalSellPriceChecked += sellPrice;
            freeTaxTotal += sellPrice;
            totalAllDiscountFreeTax += discount;
        }else{
          totalSellPriceUnchecked += sellPrice;
        }



        if (isSellPrice) {
            totalSellPrice += sellPrice;
        } else {
            totalCost += sellPrice;
        }

        totalGrossProfit += (price - costPrice) * amount;
        return { price, sellPrice, discount };
    };

    // Process all sell price items
    $('#form-estimate-nested-sell-price .nested-fields:not(:hidden)').each(function (idx, $elm) {
        processItem($elm);
    });

    // Process all cost items
    $('#form-estimate-nested-cost .nested-fields:not(:hidden)').each(function (idx, $elm) {
        processItem($elm, false);
    });

    // Process special discounts
    let totalSpecialDiscount = 0;
    $('#form-special-discount .discount-fields').each(function (idx, $elm) {
        totalSpecialDiscount += _.toNumber($($elm).find('.js-special-discount').val().replace(/,/g, '')) || 0;
    });
    totalAllDiscount += totalSpecialDiscount;

    // Calculate and update totals
    const tax = 0.1;
    summaryTotal = totalCost + totalSellPrice - totalAllDiscount;
    const totalWithTax = totalCost + totalSellPrice - freeTaxTotal - totalAllDiscount + totalAllDiscountFreeTax;
    const totalTax = totalWithTax <= 0 ? 0 : Math.round(totalWithTax * tax);
    totalGrossProfit = totalGrossProfit - totalAllDiscount
    totalGrossProfitSegmented = totalSellPrice - totalOrderValue - totalAllDiscount

    if(totalSellPriceChecked == 0){
      taxIncluded = (totalSellPriceUnchecked  - totalAllDiscount ) * 1.1
    }else if(totalSellPriceUnchecked == 0){
      taxIncluded = totalSellPriceChecked  - totalAllDiscount
    }else{
      taxIncluded = ((totalSellPriceUnchecked - totalAllDiscount) * 1.1 ) + totalSellPriceChecked
    }

    $('#total-sell-price').html('￥ ' + totalSellPrice.toLocaleString('en-US'));
    $('#total-cost-price').html('￥ ' + Math.round(totalCost).toLocaleString('en-US'));
    $('#total-all-discount').html('￥ ' + totalAllDiscount.toLocaleString('en-US'));
    $('#total-gross-profit').html('￥ ' + Math.round(totalGrossProfitSegmented).toLocaleString('en-US'));
    $('#normal-total-gross-profit').html('￥ ' + Math.round(totalGrossProfit).toLocaleString('en-US'));
    $('#summary-total').html('￥ ' + Math.round(summaryTotal).toLocaleString('en-US'));
    if($('#total-summary-tax').length > 0) {
      $('#total-summary-tax').html('￥ ' + Math.round(taxIncluded).toLocaleString('en-US'))
      $('#total-summary-tax').attr('data-value', Math.round(taxIncluded));
      // let lease_value = $('#monthly_amount').data('value') || 0;
      let lease_value = _.toNumber($('#total-lease-price').attr('data-value').toString().replace(/,/g, '')) || 0;
      if(lease_value > 0) {
        $('#normal-total-gross-profit').html('￥ ' + Math.round(totalGrossProfit - lease_value).toLocaleString('en-US'));
      }
      setTimeout(() => {
        let totalTaxWithLease = Math.round(taxIncluded + _.toNumber($('#total-lease-price').attr('data-value').toString().replace(/,/g, '')))

        $('#total_tax_with_lease').html('￥ ' + totalTaxWithLease.toLocaleString('en-US'))
        $('.total-tax-with-lease').val(totalTaxWithLease)
      }, 100);
    }
    $('#total-order-price').html('￥ ' + totalOrderValue.toLocaleString('en-US'));

    $('#tax-included').html('￥ ' + Math.round(taxIncluded).toLocaleString('en-US'));
    $('.tax-included').val((Math.round(taxIncluded)))
    calcDiscount();
  }

  function calculateOrderTotal() {
    let total = 0;
    $('.nested-fields:visible').each(function() {
      $(this).find('.ordered-container:not(.hidden) .order-details-body tr:not(.hidden)').each(function() {
      let quantity = parseFloat($(this).find('.amount-pro').val()?.replace(/,/g, '')) || 0;
      let price = parseFloat($(this).find('.price-pro').val()?.replace(/,/g, '')) || 0;
      total += quantity * price;
    });
    });

    return Math.round(total);
  }


  function calculateOrderItem($elm) {

    const $row = $($elm).closest('.nested-fields');
    let total = 0;

    $row.find('.ordered-container:not(.hidden) .order-details-body tr:not(.hidden)').each(function() {
      let quantity = parseFloat($(this).find('.amount-pro').val()?.replace(/,/g, '')) || 0;
      let price = parseFloat($(this).find('.price-pro').val()?.replace(/,/g, '')) || 0;
      total += quantity * price;
    });
    setTimeout(function () {
      $row.find('.js-purchase-amount').val(Math.round(total).toLocaleString('en-US'));
    }, 100)

  }

  function formatNumber(input) {
    let value = input.replace(/\D/g, '');

    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function getRawValue(formattedValue) {
    return parseFloat(formattedValue.replace(/,/g, '')) || 0;
  }

  function set_custom_value(costPriceDOM) {
    let isUsingIME = false;
    costPriceDOM.on('compositionstart', function() {
      isUsingIME = true;
    });

    costPriceDOM.on('compositionend', function() {
        isUsingIME = false;
        $(this).val(formatNumber($(this).val()));
    });

    costPriceDOM.on('input', function() {
      if (!isUsingIME) {
        $(this).val(formatNumber($(this).val()));
      }
    });
  }

  function removeFile(index) {
    var attachments = document.getElementById("estimate_sheet_documents").files;
    var fileBuffer = new DataTransfer();
    for (let i = 0; i < attachments.length; i++) {
      if (index !== i)
        fileBuffer.items.add(attachments[i]);
    }
    document.getElementById("estimate_sheet_documents").files = fileBuffer.files;
  }

  $(document).on('change', '#estimate_sheet_documents', function (e) {
    let $container = $(e.target).closest('.d-flex').find('.upload-list');
    $container.children('.upload-item').remove();
    const length = e.target.files.length;
    let size = $container.children('.upload-item').length;
    for (let i = 0; i < length; i++) {
      const name = e.target.files[i].name;
      const temp = "<div class='upload-item'><span class='index'>" + (++size) + ". </span> <span class='file-name'>" + name + "</span>" +
        "<div class='btn-upload-item btn-delete-file'>" +
        "<img src='/assets/icon/Delete.svg' alt='' data-index='" + i + "'/>" +
        "</div>" +
        "</div>";
      $container.append(temp);
    }
  });

  $(document).on('click', '.btn-delete-file', function (e) {
    $(this).closest('.upload-item').remove();
    removeFile($(e.target).data('index'));
  });

  $(document).on('change', '[data-react-amount], [data-react-price]', function (event) {
    $(this).attr('autocompleted', 'off');
    var $container = $(event.target).closest('.row');
    let amount = _.toNumber($container.find('[data-react-amount]').val().replace(/,/g, ''));
    let price = _.toNumber($container.find('[data-react-price]').val().replace(/,/g, ''));
    var total;
    
    if (_.isNaN(amount)) amount = 0;
    if (_.isNaN(price)) price = 0;
    total = Math.round(amount * price);


    $container.find('[data-react-total]').val(total.toLocaleString('en-US')).trigger('change');

    // Array.from(['.js-cost-price', '.js-price', '.js-sell_price']).forEach((id) => {
    //   $(id).toArray().forEach(function (field) {
    //     new Cleave(field, {
    //       numeral: true,
    //       numeralThousandsGroupStyle: 'thousand'
    //     });
    //   });
    // });
  });

  $(function () {
    var templateData = {};
    var selectbox;
    var isClickBtnSearchTemplate = false;
    var isBindClickChooseSpecsMaster = false;
    var isCopyPage = $('.page-copy').length > 0;
    assign_order_value();
    bindRemoveOrder();
    show_warehouse();
    reAddClassEstimateItemFields();
    loadCheckboxEstimateItem();
    toggleCheckboxEstimateItem();
    $(document).on('cocoon:after-insert', '.multi-field-wrapper', function (e, insertedItem) {
      let $wrapNestedElm = $(insertedItem).closest('.nested-fields');
      bindRemoveOrder();
      $wrapNestedElm.find('.form-select.select2').select2({
        theme: 'bootstrap',
        placeholder: '選択してください',
        allowClear: true,
        language: {
          noResults: function () {
            return '見つかりません。';
          },
        },
      });
      assign_order_value();
      bindClickAddOrder($wrapNestedElm);
      show_warehouse();
      bindClickChooseSpecsMaster($wrapNestedElm);
      reAddClassEstimateItemFields();
      toggleCheckboxEstimateItem();
    });

    $('#margin-number-temp').on('keydown', function (evt) {
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode === 188) return false;
      return true;
    });

    function getSelector() {
      var selector = window.insertingSelector

      if (selector.type == 'acceptingOrder') {
        return $('#' + selector.value);
      } else if (selector.type == 'estimateSheet' || selector.type == 'orderedItem') {
        return selector.value;
      }
    }

    $(document).on('click', '.btn-choose-product', function (evt) {
      var productId = $(this).attr('value');
      var $container = getSelector();
      var product_type = $(this).attr("product_type");

      $container.find('.js-product-id').attr("product_type", product_type);

      var productId = $(this).val();
      var $estimateItem = $(this).closest('.nested-fields');

      if (productId) {
        $.ajax({
          url: `/products/${productId}/load_data`,
          method: 'GET',
          success: function (res) {
            var $container = getSelector();
            var product = res.product;
            var cost = product.price_second || 0;
            var price = product.unit_price || 0;
            var product_text = product.estimate_name;
            var minPrice = product.lowest_unit_price;
            var amount = $container.find('.js-amount').val() || 0
            $container.find('.level-select').val('').trigger('change');
            if (window.insertingSelector.type == 'acceptingOrder') {
              $container.find('.js-cost-price').val(parseFloat(cost.replace(/,/g, '')).toLocaleString('en-US'));
              $container.find('.js-unit-price').val(parseFloat(price.replace(/,/g, '')).toLocaleString('en-US'));
            } else {
              let $costPrice = $container.find('.js-cost-price')
              if (!$costPrice.hasClass('segment-cost-price')){
                if(cost == 0) {
                  $costPrice.val(0);
                } else {
                  $costPrice.val(parseFloat(cost.replace(/,/g, '')).toLocaleString('en-US'));
                }
              }
              $container.find('.js-price')
                .data({
                  'product-price-min': minPrice,
                  'product-name': product_text
                })
                .val(parseFloat(price.replace(/,/g, '')).toLocaleString('en-US'))
                .trigger('change');
              var stockAmount = 0;
              $estimateItem.find('.js-amount-stock').text(stockAmount.toLocaleString('en-US'));
            }
            $container.find('.js-product-id').val(productId);
            $container.find('.js-product-text').val(product_text)
            $container.find('.js-is_freetax').attr('checked', product.is_freetax);
          },
        });
      }
      $('#modal-search-product').modal('hide');
    });

    $(document).on('click', '.js-btn-set-note', function () {
      var $wrapEstimateElm = $(this).closest('.nested-fields');
      $('#modal-specs-master-template').attr('data-estimate-id', $wrapEstimateElm.attr('id'));
      $('#modal-specs-master-template').modal('show');
    });

    $(document).on('click', '.js-add-estimate-item', function (e) {
      e.preventDefault();

      setTimeout(function () {
        var isCheckedAll = $('.toggle-check-all-object').is(':checked');
        if (isCheckedAll) {
          $('.toggle-check-all-object')
            .closest('.partner-list')
            .find('.checkbox-estimate-item')
            .prop('checked', isCheckedAll);
        }
      }, 100);
    });

    $(document).on('click', '.js-add-estimate-execution', function (e) {
      e.preventDefault();
      setTimeout(function () {
        var isCheckedAll = $('.toggle-check-all-execution').is(':checked');
        if (isCheckedAll) {
          $('.toggle-check-all-execution')
            .closest('.partner-list')
            .find('.checkbox-estimate-item')
            .prop('checked', isCheckedAll);
        }
      }, 100);
    });

    $(document).on('click', '.js-add-estimate-lease', function (e) {
      e.preventDefault();
      setTimeout(function () {
        var isCheckedAll = $('.toggle-check-all-lease').is(':checked');
        if (isCheckedAll) {
          $('.toggle-check-all-lease')
            .closest('.partner-list')
            .find('.checkbox-estimate-item')
            .prop('checked', isCheckedAll);
        }
      }, 100);
    });

    function assign_order_value() {
      $.each($('.wrap-order-list'), function (index, value) {
        $.each($(value).find('.order-number-txt'), function (order_index, order_value) {
          $(order_value).html('発注 ' + _.toString(order_index + 1));
        });
      });

      $.each($('.wrap-order-list'), function (index, value) {
        $.each($(value).find('.js-order-no'), function (order_index, order_value) {
          $(order_value)
            .val(_.toString(order_index + 1))
            .change();
        });
      });
    }

    $('.toggle-check-all-object').on('click', function () {
      var isCheckedAll = $(this).is(':checked');
      $(this).closest('.partner-list').find('.checkbox-estimate-item').prop('checked', isCheckedAll);
    });


    $('.toggle-check-all-execution').on('click', function () {
      var isCheckedAll = $(this).is(':checked');
      $(this).closest('.partner-list').find('.checkbox-estimate-item').prop('checked', isCheckedAll);
    });

    $('.toggle-check-all-lease').on('click', function () {
      var isCheckedAll = $(this).is(':checked');
      $(this).closest('.partner-list').find('.checkbox-estimate-item').prop('checked', isCheckedAll);
    });


    $(document).on('click','.btn-choose-execution', function () {
      const executionTemplateId = $(this).data('ex-template-id');
      var $container = getSelector();

      Swal.fire({
        title: "処理...",
        text: "しばらくお待ちください",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      $.ajax({
        url: `/execution_templates/${executionTemplateId}/load_data`,
        type: "GET",
        dataType: "json",
        success: function (response) {
          if (response.status !== "success" || !response.data) {
            showDialogError(response.message || "受信したデータは無効です。もう一度試してください。");
            Swal.close();
            return;
          }

          let execution_template_items;
          try {
            execution_template_items = JSON.parse(response.data);
          } catch (e) {
            showDialogError("受信したデータは無効です。もう一度試してください。");
            Swal.close();
            return;
          }

          if (!execution_template_items) {
            showDialogError("受信したデータは無効です。もう一度試してください。");
            Swal.close();
            return;
          }

          let execution_template_items_length = execution_template_items.length;
          $container.find('.js-price').data('product-price-min', '');
          let elements = $container.add(
            $container.nextAll('.nested-fields:visible').slice(0, execution_template_items_length - 1)
          );

          setTimeout(() => {
            handleImportExecutionTemplate(elements, execution_template_items);
            Swal.close();
            showDialogSuccess(response.message);
          }, 200);
        },
        error: function (xhr) {
          let errorMessage = "データ入力に失敗しました。もう一度お試しください。";

          if (xhr.responseJSON && xhr.responseJSON.message) {
            errorMessage = xhr.responseJSON.message;
          }

          showDialogError(errorMessage);
          Swal.close();
        }
      });
      $('#modal-search-product').modal('hide');
    });


    function handleImportExecutionTemplate(nestedFields, executionTemplateItems) {

      let $firstRow = nestedFields.first();
      let missingRows = executionTemplateItems.length - nestedFields.length;

      if (missingRows > 0) {
        let $lastRow = $firstRow;
        _.times(missingRows, () => {
          $lastRow = addNewNestedField($lastRow);
        });

        let updatedNestedFields = $firstRow.add(
          $firstRow.nextAll('.nested-fields:visible').slice(0, executionTemplateItems.length - 1)
        );

        updateValueRows(updatedNestedFields, executionTemplateItems);
      } else {
        updateValueRows(nestedFields, executionTemplateItems);
      }
    }

    function updateValueRows(nestedFields, executionTemplateItems) {
      let updatedElements = $();
      nestedFields.each(function (index) {
        let $row = $(this);
        let data = executionTemplateItems[index];

        if (data) {
          let values = {
            '.level-select': data.level,
            '.js-product-text': data.name || data.product_lable,
            '.js-product-id': data.product_id,
            '.js-amount': data.amount,
            '.js-unit': data.unit,
            '.js-price': data.price,
            '.sell-price': data.sell_price
          };

          let inputs = Object.keys(values).map(selector => [$row.find(selector), selector]);

          inputs.forEach(([$input, selector]) => {
            if ($input.length) {
              $input.val(values[selector]);
              updatedElements = updatedElements.add($input);
            }
          });
        }
      });
      updatedElements.trigger("change");
    }

    function toggleCheckboxEstimateItem() {

      $('.checkbox-estimate-item').on('click', function () {
        const checkboxes = $('.checkbox-estimate-item');
        var isChecked = $(this).is(':checked');
        if (!isChecked) {
          $(this)
            .closest('.partner-list')
            .find('.toggle-check-all-object')
            .prop('checked', isChecked);
        } else {
          $(this).closest('.partner-list').find('.toggle-check-all-object').prop('checked', true);
        }
      });

      $('.checkbox-estimate-item').on('click', function () {
        var isChecked = $(this).is(':checked');
        if (!isChecked) {
          $(this)
            .closest('.partner-list')
            .find('.toggle-check-all-execution')
            .prop('checked', isChecked);
        } else {
          var checkboxEstimateItems = $(this)
            .closest('.partner-list')
            .find('.checkbox-estimate-item')
            .slice(1);
          var elements = [];
          _.forEach(checkboxEstimateItems, function (item) {
            var checked = $(item).is(':checked');
            if (checked) {
              elements.push(item);
            }
          });
          if (checkboxEstimateItems.length == elements.length) {
            $(this)
              .closest('.partner-list')
              .find('.toggle-check-all-execution')
              .prop('checked', true);
          }
        }
      });

      $('.checkbox-estimate-item').on('click', function () {
        var isChecked = $(this).is(':checked');
        if (!isChecked) {
          $(this)
            .closest('.partner-list')
            .find('.toggle-check-all-lease')
            .prop('checked', isChecked);
        } else {
          var checkboxEstimateItems = $(this)
            .closest('.partner-list')
            .find('.checkbox-estimate-item')
            .slice(1);
          var elements = [];
          _.forEach(checkboxEstimateItems, function (item) {
            var checked = $(item).is(':checked');
            if (checked) {
              elements.push(item);
            }
          });
          if (checkboxEstimateItems.length == elements.length) {
            $(this)
              .closest('.partner-list')
              .find('.toggle-check-all-lease')
              .prop('checked', true);
          }
        }
      });
    }

    function loadCheckboxEstimateItem() {
      _.forEach($('.partner-list'), function ($elm, idx) {
        var newAction = document.getElementById('new_estimate_sheet');
        var checkboxEstimateItems = $($elm).find('.checkbox-estimate-item').slice(1);
        var elements = [];
        if (newAction && newAction.length > 0) {
          _.forEach(checkboxEstimateItems, function (item) {
            $(item).prop('checked', true);
            elements.push(item);
          });
        } else {
          var firstCheckbox = $($elm).find('.toggle-check-all-execution');
          var checkboxObject = $($elm).find('.toggle-check-all-object');
          var checkboxLease = $($elm).find('.toggle-check-all-lease');
          _.forEach(checkboxEstimateItems, function (item) {
            var checked = $(item).is(':checked');
            if (checked) {
              elements.push(item);
            }
          });

          if (checkboxEstimateItems.length == elements.length) {
            $($elm).find('.toggle-check-all-execution').prop('checked', true);
            $($elm).find('.toggle-check-all-object').prop('checked', true);
            $($elm).find('.toggle-check-all-lease').prop('checked', true)
          } else {
            if (firstCheckbox.val()) {
              $($elm).find('.toggle-check-all-execution').prop('checked', false);
            } else {
              $($elm).find('.toggle-check-all-execution').prop('checked', false);
            }

            if (checkboxObject.val()) {
              $($elm).find('.toggle-check-all-object').prop('checked', false);
            } else {
              $($elm).find('.toggle-check-all-object').prop('checked', false);
            }

            if (checkboxLease.val()) {
              $($elm).find('.toggle-check-all-lease').prop('checked', false);
            } else {
              $($elm).find('.toggle-check-all-lease').prop('checked', false);
            }
          }
        }
      });
    }

    function bindRemoveOrder() {
      $('.remove-order-item').on('click', function () {
        $(this).closest('.order-item-clone').remove();
        assign_order_value();
      });
    }

    function bindClickAddOrder($wrapNestedElm) {
      $($wrapNestedElm)
        .find('.btn-add-order')
        .on('click', function () {
          var $orderItem = $('.order-item-clone.d-none').clone();
          $orderItem.removeClass('d-none');
          var currentNumber = $(this).closest('.nested-fields').find('.order-item-clone').length + 1;
          $orderItem.find('span.order-number-txt').html('発注 ' + _.toString(currentNumber));
          $(this).closest('.nested-fields').find('.wrap-order-list').append($orderItem);
        });
    }



    function bindClickChooseSpecsMaster($wrapElem) {
      if (isBindClickChooseSpecsMaster) return;

      $('.js-choose-specs-master').on('click', function () {
        var currentId = $('#modal-specs-master-template').attr('data-estimate-id');
        var $currentEstimateItem = $(`#${currentId}`);
        var specsMaster = $(this).closest('.row').data('values');
        if ($currentEstimateItem) {
          var specification = _.toString(specsMaster.specification).slice(0, 70);
          $($currentEstimateItem).find('.line_note').val(specification);
        }

        $('#modal-specs-master-template').modal('hide');
        isBindClickChooseSpecsMaster = true;
      });
    }

    _.forEach($('#form-estimate-nested-sell-price .nested-fields'), function ($elm) {
      bindClickChooseSpecsMaster($elm);
    });

    function reAddClassEstimateItemFields() {
      _.forEach($('.nested-fields'), function ($elm, idx) {
        $($elm).attr('id', `estimate-item-${idx}`);
      });
    }

    $('.btn-open-template').on('click', function () {
      if (isClickBtnSearchTemplate) {
        $('.execution-template-name').val('');
        $('#modal-execution-template .search-execution-template').trigger('click');
      }
      $('#modal-execution-template').modal('show');
      isClickBtnSearchTemplate = true;
    });

    $('.js-duplicate-sheet').on('click', function () {
      const tab = $(this).data('tab');
      $.ajax({
        url: `/estimate_sheets/${$('#button_copy_estimate_sheet').data( "id")}/copy`,
        method: 'post',
        success: function (res) {
          if (tab) {
            window.location.search = `?current_tab=${tab}`;
          } else {
            window.location.reload();
          }
        },
      });
      // var originalId = $('.esimate-sheet-page').data('esti-sheet-id');
      // if (originalId) {
      //   window.open(`/estimate_sheets/new?original_id=${originalId}&is_copy=true`, '_blank').focus();
      //   $('#modal_add_new_estimate_sheet').modal('hide');
      //   return;
      // }
      // var columns = $('.esimate-sheet-page').data('attrs');
      // var orderColumns = $('.esimate-sheet-page').data('order-attrs');
      // // es = estimate_sheet
      // var estimates = { es: {} };
      // var modelName = 'estimate_sheet';
      // _.forEach(columns, function (column) {
      //   var val = $('.form-estimate-sheet')
      //     .find("input[name*='" + modelName + '[' + column + "]']:last")
      //     .val();
      //   if (!val)
      //     val = $('.form-estimate-sheet')
      //       .find("select[name*='" + modelName + '[' + column + "]']:last")
      //       .val();
      //   if (!val)
      //     val = $('.form-estimate-sheet')
      //       .find("textarea[name*='" + modelName + '[' + column + "]']:last")
      //       .val();
      //   if (column == 'accept_status') {
      //     val = $('.form-estimate-sheet').find(`input[name*='accept_status']:checked`).val();
      //   }
      //   estimates['es'][column] = val;
      // });
      // var discounts = [];
      // _.forEach($('.nested-fields.discount-fields'), function ($discountElm) {
      //   discounts.push({
      //     title: $($discountElm).find('.js-discount-title').val(),
      //     amount: $($discountElm).find('.js-special-discount').val(),
      //   });
      // });
      // estimates['es']['discounts_attributes'] = discounts;

      // var estimateItems = [];
      // _.forEach($('.nested-fields.nested-fields:not(:hidden)'), function ($esmItem) {
      //   var price = $($esmItem).find('.js-price').val();
      //   var sellPrice = $($esmItem).find('.js-sell_price').val();
      //   var esmItem = {
      //     product_text: $($esmItem).find('.js-product-text').val(),
      //     product_id: $($esmItem).find('.js-product-id').val(),
      //     amount: $($esmItem).find('.js-amount').val(),
      //     unit: $($esmItem).find('.js-unit').val(),
      //     cost_price: $($esmItem).find('.js-cost-price').val(),
      //     price: price == 0 ? '' : price,
      //     sell_price: sellPrice == 0 ? '' : sellPrice,
      //     note: $($esmItem).find('.js-note').val(),
      //     discount: $($esmItem).find('.js-discount').val(),
      //     is_ordered: $($esmItem).find('.form-check-input').is(':checked'),
      //     company_id: $($esmItem).find('.estimate-sheet-company-id').val(),

      //     // is_ordered: false,
      //     // company_id: '',
      //     discount: $($esmItem).find('.js-discount').val(),
      //     warehouse_quantity: $($esmItem).find('.js-warehouse_quantity').val(),
      //   };

      //   var orderSheets = [];
      //   _.forEach($($esmItem).find('.order-item-clone'), function ($orderItem) {
      //     var orderSheetItem = {};
      //     _.forEach(orderColumns, function (orderAttr) {
      //       var orderVal = $($orderItem)
      //         .find("[name$='[" + orderAttr + "]']")
      //         .val();
      //       orderSheetItem[orderAttr] = orderVal;
      //     });
      //     var isExistSheet = !_.every(orderSheetItem, function (val, key) {
      //       return _.isEmpty(val);
      //     });
      //     if (isExistSheet) {
      //       orderSheets.push(orderSheetItem);
      //     }
      //   });
      //   esmItem['estimate_item_orders_attributes'] = orderSheets;
      //   var isExistItem = !_.every(esmItem, function (val, key) {
      //     return _.isEmpty(val);
      //   });
      //   if (isExistItem) {
      //     esmItem['able_print'] = $($esmItem).find('.js-product-id').val();
      //     esmItem['estimate_item_type'] = $($esmItem).find('.estimate-item-type').val();
      //     estimateItems.push(esmItem);
      //   }
      // });
      // // eits = estimate_items_attributes for short name
      // estimates['es']['eits'] = estimateItems;
      // var expandPrams = $.param(estimates);
      // console.log(expandPrams.length);

      // $('#modal_add_new_estimate_sheet').modal('hide');
      // window
      //   .open(`/estimate_sheets/new?original_id=${originalId}&is_copy=true&${expandPrams}`, '_blank')
      //   .focus();
    });

    $('.js-submit-template').on('click', function () {
        var executionTemplateDetailIds = _.map(
          $('#template-item-content').find('.template-item-clone'),
          function ($elm) {
            return $($elm).attr('id');
          }
        );
        if (!_.isEmpty(executionTemplateDetailIds)) {
          $.ajax({
            url: `/execution_templates/load_execution_template_items?ids=${executionTemplateDetailIds}`,
            method: 'GET',
            success: function (res) {
              if (!_.isEmpty(res.templates)) {
                var templates = res.templates;
                _.forEach(templates, function (item) {
                  $('.btn-add-execution').trigger('click');
                });
                setTimeout(function () {
                  var templateLength = templates.length;
                  var idx = 0;
                  _.forEach(
                    _.reverse($('#form-estimate-nested-cost .nested-fields:not(:hidden)')),
                    function ($elm) {
                      if (idx < templateLength) {
                        var currentTem = templates[idx];
                        _.forEach(
                          [
                            'product_id',
                            'amount',
                            'cost_price',
                            'note',
                            'price',
                            'unit',
                            'sell_price',
                            'discount',
                          ],
                          function (field) {
                            let value = currentTem[field];

                            if (value !== undefined && field === 'sell_price') {
                              value = Math.round(value);
                            }

                            $($elm).find(`.js-${field}`).val(value).change();
                          }
                        );
                      }
                      idx = idx + 1;
                    }
                  );
                }, 500);
              }
            },
          });
        }
      });

      estimateSheetCalcTotal(false);

    $(document).on('click', '.confirm-export-est', function () {
      var estimate_sheet_id = $(this).data('id');
      var estimate_type = $(this).data('est-type');
      var estimate_payment = $(this).data('est-payment')
      var url = $(this).data('pdf-path').replace(/"/g, '');
      var export_type = $(this).data('export-type');
      const validPaymentCondition = ['transfer_deposit', 'transfer_debit', 'transfer_subsidy']

      let object = '';
      if(estimate_type == 'normal') {
        object = '#export-confirm-modal';
        let bankSection = $(object).find('.bank-transfer-section');
        let titleSection = $(object).find('.title-selection-section');
        let title = $(object).find('.title');

        titleSection.show();

        if (validPaymentCondition.includes(estimate_payment)) {
          bankSection.show();
          $('.title-selection-label').show();
          title.text('振込先の記載有無設定');
        } else {
          bankSection.hide();
          $('.title-selection-label').hide();
          title.text('見積書タイトル選択');
        }


      } else if(estimate_type == 'segmented') {
        object = '#export-confirm-modal';
        let bankSection = $(object).find('.bank-transfer-section');
        let titleSection = $(object).find('.title-selection-section');
        let title = $(object).find('.title')

        titleSection.show();
        if (validPaymentCondition.includes(estimate_payment)) {
          bankSection.show();
          $('.title-selection-label').show();
          title.text('振込先の記載有無設定');
        } else {
          bankSection.hide();
          $('.title-selection-label').hide();
          title.text('見積書タイトル選択');
        }

      } else {
        object = '#export-confirm-lease-modal';
        let children = $(object).find('.bank-radio').children('label');
        let title = $(object).find('.title');
        if (!validPaymentCondition.includes(estimate_payment)) {
          for (let i = 0; i < children.length; i++) {
            children[i].style.display = "none";
          }
          title.text('顧客の担当者設定')
        } else {
          for (let i = 0; i < children.length; i++) {
            children[i].style.display = "block";
          }
          title.text('振込先の記載有無設定')
        }
      }

      const $modal = $(object);
      $modal.find('.js-pic-name').val('');
      let selectedBankValue = $(object).find(".is_show_bank:checked").val() || 'false';
      let selectedTitle = $(object).find(".estimate_title:checked").val() || '見積書兼発注書';
      let picValue = encodeURIComponent($modal.find('.js-pic-name').val() || '');

      url += `?include_bank=${selectedBankValue}&estimate_title=${encodeURIComponent(selectedTitle)}&pic_name=${picValue}`;

      if(export_type == 'print') {
        $(object).find('.js-export-pdf-est').html(`<div data-est-sheet-id="${estimate_sheet_id}" data-pdf-path="${url}">出力</div>`)
      } else {
        $(object).find('.js-export-pdf-est').html(`<a href="${url}" style="color: white; text-decoration: none;">出力</a>`)
      }
      $(object).modal('show')
    })

    $('#export-confirm-modal, #export-confirm-lease-modal').on('shown.bs.modal', function () {
      const $modal = $(this);
      if (!$modal.find(".is_show_bank:checked").length) {
        $modal.find('input[name="is_show_bank"][value="false"]').prop('checked', true);
      }

      if (!$modal.find(".estimate_title:checked").length) {
        $modal.find('input[name="estimate_title"][value="見積書兼発注書"]').prop('checked', true);
      }
    });

    $(document).on('change', '.is_show_bank', function () {
      const $modal = $(this).closest('.modal');
      let selectedValue = $(this).val();

      $modal.find(".js-export-pdf-est").each(function () {
        let $container = $(this);

        $container.find("div").each(function () {
          let currentPath = $(this).attr("data-pdf-path") || "";
          let newPath = updateQueryString(currentPath, "include_bank", selectedValue);
          $(this).attr("data-pdf-path", newPath);
        });

        $container.find("a").each(function () {
          let currentHref = $(this).attr("href") || "";
          let newHref = updateQueryString(currentHref, "include_bank", selectedValue);
          $(this).attr("href", newHref);
        });
      });
    })

    $(document).on('input', '.js-pic-name', function () {
      const $modal = $(this).closest('.modal');
      let picValue = encodeURIComponent($(this).val() || '');

      $modal.find(".js-export-pdf-est").each(function () {
        let $container = $(this);

        $container.find("div").each(function () {
          let currentPath = $(this).attr("data-pdf-path") || "";
          let newPath = updateQueryString(currentPath, "pic_name", picValue);
          $(this).attr("data-pdf-path", newPath);
        });

        $container.find("a").each(function () {
          let currentHref = $(this).attr("href") || "";
          let newHref = updateQueryString(currentHref, "pic_name", picValue);
          $(this).attr("href", newHref);
        });
      });
    })

    $(document).on('change', '.estimate_title', function () {
      const $modal = $(this).closest('.modal');
      let selectedTitle = $(this).val();

      $modal.find(".js-export-pdf-est").each(function () {
        let $container = $(this);

        $container.find("div").each(function () {
          let currentPath = $(this).attr("data-pdf-path") || "";
          let newPath = updateQueryString(currentPath, "estimate_title", encodeURIComponent(selectedTitle));
          $(this).attr("data-pdf-path", newPath);
        });

        $container.find("a").each(function () {
          let currentHref = $(this).attr("href") || "";
          let newHref = updateQueryString(currentHref, "estimate_title", encodeURIComponent(selectedTitle));
          $(this).attr("href", newHref);
        });
      });
    })

    $(document).on('click', '.js-export-pdf-est', function (event) {
      event.preventDefault();
      let currentUrl = $(this).find('a').attr('href');
      if(currentUrl.split('/').includes('export')) {
        window.location.href = currentUrl;
      }

      $('.js-pic-name').val('');
      $('.is_show_bank[value="false"]').prop('checked', true);
      $('.estimate_title[value="見積書兼発注書"]').prop('checked', true);
      $('#export-confirm-modal').modal('hide');
      $('#export-confirm-lease-modal').modal('hide');
    })

    $(document).on('hidden.bs.modal', '#export-confirm-modal, #export-confirm-lease-modal', function () {
      $(this).find('input[name="is_show_bank"][value="false"]').prop('checked', true);
      $(this).find('input[name="estimate_title"][value="見積書兼発注書"]').prop('checked', true);
      $(this).find('.js-pic-name').val('');
    })

    $('#export-confirm-modal, #export-confirm-lease-modal').on('hidden.bs.modal', function() {
      $(this).find('input[name="is_show_bank"][value="false"]').prop('checked', true);
      $(this).find('input[name="estimate_title"][value="見積書兼発注書"]').prop('checked', true);
      $(this).find('.js-pic-name').val('');
    })

    function updateQueryString(url, key, value) {
      let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
      let separator = url.indexOf("?") !== -1 ? "&" : "?";

      if (url.match(re)) {
        return url.replace(re, "$1" + key + "=" + value + "$2");
      } else {
        return url + separator + key + "=" + value;
      }
    }

    $(document).on('click', 'div[data-est-sheet-id]:not(.confirm-export-est)', function () {
      const id = this.getAttribute('data-est-sheet-id');
      $('body').loading({
        message: '書類の取得...',
      });

      $.ajax({
        method: 'PUT',
        url: `/estimate_sheets/${id}/update_printed`,
      });
      const url = this.getAttribute('data-pdf-path').replace(/"/g, '');
      $.ajax({
        url: `${url}`,
        type: 'GET',
        xhrFields: {
          responseType: 'blob'
        },
        success: function(blob) {
          var url = window.URL.createObjectURL(blob);
          var iframe = document.createElement('iframe');
          iframe.style.display = 'none';
          iframe.src = url;
          document.body.appendChild(iframe);

          iframe.onload = function() {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            $('body').loading('destroy');
          };
        },
        error: function(error) {
          $('body').loading('destroy');
        }
      });
    });

    $('span[data-est-sheet-id]').on('click', function () {
      $('body').loading({
        message: '書類の取得...',
      });
      var id = this.getAttribute('data-est-sheet-id');
      $.ajax({
        method: 'PUT',
        url: `/estimate_sheets/${id}/update_printed`,
      });
      setTimeout(() => {
        $('body').loading('destroy');
      }, 3000);
    });

    $('.arrow-down-main').on('click', function () {
      $('.table-form-estimate-sheet').find('tr:not(.ignore-hide)').removeClass('d-none');
      $('.arrow-up-main').removeClass('d-none');
      $(this).addClass('d-none');
    });

    $('.arrow-up-main').on('click', function () {
      $('.table-form-estimate-sheet').find('tr:not(.ignore-hide)').addClass('d-none');
      $('.arrow-down-main').removeClass('d-none');
      $(this).addClass('d-none');
    });

    $(document).on('click', '.toggle-up', function () {
      var $closestParent = $(this).closest('.nested-fields');
      $closestParent.find('.toggle-down').removeClass('d-none');
      $closestParent.find('.multi-collapse').removeClass('show');
      $(this).addClass('d-none');
    });

    $(document).on('click', '.arrow-up', function () {
      var $closestParent = $(this).closest('.nested-fields');
      $closestParent.find('.arrow-down').removeClass('d-none');
      $closestParent.find('.wrap-expand-arrow').addClass('d-none');
      $(this).addClass('d-none');
    });

    $(document).on('click', '.toggle-down', function () {
      var $closestParent = $(this).closest('.nested-fields');
      $closestParent.find('.toggle-up').removeClass('d-none');
      $closestParent.find('.multi-collapse').addClass('show');
      $(this).addClass('d-none');
    });

    $(document).on('click', '.arrow-down', function () {
      var $closestParent = $(this).closest('.nested-fields');
      $closestParent.find('.arrow-up').removeClass('d-none');
      $closestParent.find('.wrap-expand-arrow').removeClass('d-none');
      $(this).addClass('d-none');
    });

    $('.esimate-sheet-page').on('cocoon:after-insert', function (e, insertItem) {
    });

    $(document).on('cocoon:after-insert', '.partner-list', function (e, insertedItem, originalEvent) {
    });

    $('.cal-estimate-price').on('click', function () {
      if ($("#estimate_sheet_is_final").attr('disabled') == 'disabled') {
        return false
      }
      $('#modal_confirm_calc').modal('show');
    });

    $('.new-estimate-sheet').on('click', function (e) {
      var id = $(this).data("item-id")
      if ($("#estimate_sheet_is_final").attr('disabled') == 'disabled' || $(e.target).attr('disabled') == 'disabled') {
        return false
      }
      const tab = $(this).data('tab');
      $('#modal_add_new_estimate_sheet').modal('show');
      $('#button_copy_estimate_sheet').data( "id", id);
      $('#button_copy_estimate_sheet').data( "tab", tab);
    });

    $('#add_new_estimate_sheet').on('click', function () {
      var root = $(this).closest('a');
      var href = $(root)[0].href;
      window.open(href, '_blank').focus();
    });

    function show_warehouse() {
      $('.js-product-id').on('change', function (e) {
        var product_type = $(this).attr('product_type');
        var parent_nested_field = $(this).closest('.nested-fields');
        if (product_type === 'object') {
          parent_nested_field.find('.show-warehouse').removeClass('hidden');
        } else {
          parent_nested_field.find('.show-warehouse').addClass('hidden');
        }
      });

      $('.show-stocks').on('click', function () {
        var parent_nested_field = $(this).closest('.nested-fields');
        var product_type = parent_nested_field.find('.js-product-id').attr('product_type');
        if (product_type === 'object') {
          parent_nested_field.find('.show-warehouse').removeClass('hidden');
        } else {
          parent_nested_field.find('.show-warehouse').addClass('hidden');
        }
      });
    }

    $(document).on('click', '#check_all_est', function (event) {
      $('.check-est-item').prop('checked', $(this).prop('checked'));
    });

    $('#approve_all_est').on('click', function () {
      var checkedValues = $('.check-est-item:checkbox:checked')
        .map(function () {
          return this.name;
        })
        .get();

      $.ajax({
        url: '/estimate_sheets/approve_all_est',
        method: 'PUT',
        data: { estimate_sheet_ids: checkedValues },
        success: function (res) {
          window.location = '/estimate_sheets';
        },
      });
    });

    var isFormProject = $('.esimate-sheet-page').data('is-from-project');
    if (isFormProject || isCopyPage) {
      setTimeout(function () {
        $('.estimate-sheet-project-id').trigger('change');
      }, 200);
    }

    // $('.estimate-sheet-project-id').on('change', function () {
    //   var projectId = $(this).val();

    //   if (projectId) {
    //     $('.estimate-sheet-acceptor-ids')
    //       .html('')
    //       .select2({ data: [{ id: '', text: '' }] });
    //     $.ajax({
    //       url: '/estimate_sheets/load_workers',
    //       method: 'GET',
    //       data: { project_id: projectId },
    //       success: function (res) {
    //         var managers = _.map(res.managers, function (worker) {
    //           return { id: worker.id, text: worker.fullname };
    //         });
    //         $('.estimate-sheet-acceptor-ids').html('').select2({ data: managers });
    //         $('.estimate-sheet-acceptor-ids').prop('disabled', false);
    //         resetSelect2($('.estimate-sheet-acceptor-ids'));
    //         if(res.company_id != undefined) {
    //           $('.estimate-sheet-company-id').val(res.company_id).trigger('change');
    //         }
    //         $('.estimate-sheet-acceptor-ids').trigger('change');
    //         if (isCopyPage) {
    //           $('.estimate-sheet-worker-ids').val($('.wrap-assign-worker-ids').data("ids"));
    //           $('.estimate-sheet-worker-ids').trigger('change');
    //           $('.estimate-sheet-company-id').val($('.wrap-assign-company-id').data("id"));
    //           $('.estimate-sheet-company-id').trigger('change');
    //         }
    //       },
    //     });
    //   } else {
    //     $('.estimate-sheet-worker-ids').prop('disabled', true);
    //   }
    // });
    $('.estimate-sheet-project-id').on('change', function () {
      var nameProject = $(this).find("option:selected").text();
      $("#estimate_sheet_name").val(nameProject);
      var project_id = $(this).val();
      if(project_id) {
        $.ajax({
          method: 'get',
          url: `/projects/${project_id}/check_is_final`,
          success: function(e) {
            if(e.is_final == true) {
              $('#estimate_sheet_is_final').attr('disabled', true);
            } else {            ;
              $('#estimate_sheet_is_final').attr('disabled', false);
            }
          }
        })
      }
    });

    function resetSelect2($elm) {
      $($elm).select2({
        theme: 'bootstrap',
        placeholder: '選択してください',
        allowClear: true,
        language: {
          noResults: function () {
            return '見つかりません。';
          },
        },
      });
    }

    // Do not call HTMLFormElement.submit() here — it bypasses ActiveStorage direct-upload
    // listeners and causes a second POST after upload completes (duplicate EstimateSheets).
    // ActiveStorage preventDefault's the first submit, uploads, then clicks submit again.
    // This listener runs before that preventDefault, so a pending file must not be treated
    // as the real submit or the follow-up submit is blocked and the form never posts.
    $(document).on('submit', '.form-estimate-sheet', function (e) {
      const $form = $(this);
      const hasPendingDirectUpload = $form.find('input[type=file][data-direct-upload-url]:not([disabled])').toArray()
        .some(function (input) { return input.files && input.files.length > 0; });

      if (hasPendingDirectUpload || e.isDefaultPrevented() || $form.is('[data-direct-uploads-processing]')) {
        return;
      }

      if ($form.data('submitting')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }

      $form.data('submitting', true);
      $form.find('.btn-save, .btn-save-estimate-lease').prop('disabled', true);
    });

    $(document).on('direct-upload:error', 'form.form-estimate-sheet input[type=file]', function () {
      const $form = $(this).closest('form.form-estimate-sheet');
      $form.removeData('submitting');
      $form.find('.btn-save, .btn-save-estimate-lease').prop('disabled', false);
    });
  });

  $(document).on('click', '.btn-open-search-product', function (evt) {
    $('.select-search-category').select2({
      theme: 'bootstrap',
      allowClear: true,
      dropdownParent: $('#modal-search-product'),
      language: {
        noResults: function () {
          return '見つかりません。';
        },
      },
    })
    $('.select-search-category').val('').trigger('change');

    $('.select-search-product').select2({
      theme: 'bootstrap',
      allowClear: true,
      dropdownParent: $('#modal-search-product'),
      language: {
        noResults: function () {
          return '見つかりません。';
        },
      },
    });
    $('.select-search-product').val('').trigger('change');
    var nameSearching = $(evt.target).closest('div').find('.js-product-text').val()
    $('#modal-search-product #q_companies_name_cont').val('');
    $('#modal-search-product #q_name_cont').val('');
    $('#modal-search-product #q_price_gteq').val('');
    $('#modal-search-product #q_price_lteq').val('');
    // $('#modal-search-product #q_name_cont').val(nameSearching);
    $('.btn-submit.search-product').trigger('click');
    $('.btn-submit.search-execution-template').trigger('click');
    var nestedField = $(evt.target).closest('.nested-fields');
    var insertingSelector = nestedField.length > 0 ? { type: 'estimateSheet', value: $(evt.target).closest('.nested-fields') } : { type: 'acceptingOrder', value: $(evt.target).closest('form').attr('id') }
    window.insertingSelector = insertingSelector
    $('#modal-search-product').modal('show');
  });

  $(document).on('click', '.checkbox-estimate-item', function () {
    var isChecked = $(this).is(':checked');
    const checkboxes = $(this).closest('.partner-list').find('.checkbox-estimate-item');
    if (!isChecked) {
      $(this)
        .closest('.partner-list')
        .find('.toggle-check-all-object')
        .prop('checked', isChecked);
    } else {
      const allChecked = checkboxes.length === checkboxes.filter(':checked').length;
      $(this).closest('.partner-list').find('.toggle-check-all-object').prop('checked', allChecked);
    }

    if (!isChecked) {
      $(this)
        .closest('.partner-list')
        .find('.toggle-check-all-execution')
        .prop('checked', isChecked);
    } else {
      var checkboxEstimateItems = $(this)
        .closest('.partner-list')
        .find('.checkbox-estimate-item')
        .slice(1);
      var elements = [];
      _.forEach(checkboxEstimateItems, function (item) {
        var checked = $(item).is(':checked');
        if (checked) {
          elements.push(item);
        }
      });
      if (checkboxEstimateItems.length == elements.length) {
        $(this)
          .closest('.partner-list')
          .find('.toggle-check-all-execution')
          .prop('checked', true);
      }
    }
  });

  $(document).on('click', '.js-submit-template', function () {
    var executionTemplateDetailIds = _.map(
      $('#template-item-content').find('.template-item-clone'),
      function ($elm) {
        return $($elm).attr('id');
      }
    );
    if (!_.isEmpty(executionTemplateDetailIds)) {
      $.ajax({
        url: `/execution_templates/load_execution_template_items?ids=${executionTemplateDetailIds}`,
        method: 'GET',
        success: function (res) {
          if (!_.isEmpty(res.templates)) {
            var templates = res.templates;
            _.forEach(templates, function (item) {
              $('.btn-add-execution').trigger('click');
            });
            setTimeout(function () {
              var templateLength = templates.length;
              var idx = 0;
              _.forEach(
                _.reverse($('#form-estimate-nested-cost .nested-fields:not(:hidden)')),
                function ($elm) {
                  if (idx < templateLength) {
                    var currentTem = templates[idx];
                    _.forEach(
                      [
                        'product_id',
                        'amount',
                        'cost_price',
                        'note',
                        'price',
                        'unit',
                        'sell_price',
                        'discount',
                      ],
                      function (field) {
                        var value = currentTem[field];

                        if (value !== undefined) {
                          if (field === 'sell_price') {
                            value = Math.round(value);
                          }
                        } else {
                          value = '';
                        }

                        $($elm).find(`.js-${field}`).val(value).change();
                      }
                    );
                  }
                  idx = idx + 1;
                }
              );
            }, 500);
          }
        },
      });
    }
  });

  $(document).on('click', '#confirm_calc', function () {
    var marginNumber = _.toNumber($('.margin-number-temp').val()) || 0;
    const id = $('.esimate-sheet-page')[0].getAttribute('data-esti-sheet-id');
    if (id) {
      $.ajax({
        method: 'PUT',
        url: `/estimate_sheets/${id}/update_margin_number`,
        data: { margin_number: marginNumber },
      });
    }
    estimateSheetCalcTotal(true);
  });

  $(document).on('click', '.calc_discount', function () {
    calcDiscount();
  });

  $(document).on('change', 'form.form-estimate-sheet ', function (e) {
    $('.new-estimate-sheet').addClass('opacity-50');
    $('.new-estimate-sheet').attr('disabled', 'disabled');
  })

  $(document).on('click', '.js-choose-template', function () {
    var templates = _.reverse($(this).closest('.row').data('values'));

    _.forEach(templates, function (item) {
      $('.js-add-execution').trigger('click');
      _.times(1, function (idx) {
        var isCheckedAllE = $('.toggle-check-all-execution').is(':checked');
        $('.toggle-check-all-execution')
          .closest('.partner-list')
          .find('.checkbox-estimate-item')
          .prop('checked', isCheckedAllE);
      });
    });

    setTimeout(function () {
      templates = templates.sort(function(a, b) {
                    var keyA = a.sort_index,
                      keyB = b.sort_index;
                    if (keyA < keyB) return -1;
                    if (keyA > keyB) return 1;
                    return 0;
                  });
      var templateLength = templates.length;
      var idx = 0;
      var countFieldEmpty = $("#form-estimate-nested-cost .nested-fields:not(:hidden)").length;
      _.forEach($("#form-estimate-nested-cost .nested-fields:not(:hidden)"), function ($elm) {
        var checkEmpty = true
        Array.from($elm.getElementsByClassName('form-control')).forEach((el) => {
          if(el && el.value){
            checkEmpty = false;
          }
        });
        if (!checkEmpty){
          countFieldEmpty = countFieldEmpty - 1;
        }
      })

      if(templateLength > countFieldEmpty){
        for(var i = 0; i < templateLength - countFieldEmpty; i++) {
          $( ".js-add-estimate-execution" ).trigger( "click" );
        }
      }
      _.forEach($("#form-estimate-nested-cost .nested-fields:not(:hidden)"), function ($elm) {
        var checkEmpty = true
        Array.from($elm.getElementsByClassName('form-control')).forEach((el) => {
          if(el && el.value){
            checkEmpty = false;
          }
        });
        if(!checkEmpty){
          return true;
        }

        if (idx < templateLength) {

        var currentTem = templates[idx];
        _.forEach(["name", "amount", "cost_price", "note", "price", "unit", "sell_price", "discount sell_price"], function (field) {
          var value = currentTem[field];

          if (value != null) {
            if (field === "sell_price") {
              value = Math.round(value).toLocaleString('en-US');
            }
            value = value.toLocaleString('en-US');
          } else {
            value = '';
          }
          $($elm).find('.js-product-id').val(currentTem.product_id);
          $($elm).find(`.js-${field}`).val(value).change();
        });
      }

        idx = idx + 1;
      })
      showDialogSuccess('データを正常に入力しました');
    }, 500);
  });

  $(document).ready(function() {
    $(document).on('change', '.estimate-sheet-company-id', function() {
      var input_name = $(this).attr('name').split('[').slice(0, 3).join('[');
      var selectedCompanies = $(this).val() || [];
      var orderDetailsTable = $(this).closest('.ordered-item-area').find('.order-details-table');
      var orderDetailsBody = $(this).closest('.ordered-item-area').find('.order-details-body');

      if (selectedCompanies.length === 0) {
          orderDetailsTable.addClass('hidden');


          orderDetailsBody.find('tr').each(function() {
              var nestedIndex = $(this).find('input[name*="[company_id]"]').attr('name').match(/\[(\d+)\]/g)[1].replace(/\D/g, '');

              if (!$(this).find('input[name*="[_destroy]"]').length) {
                  $(this).append('<input type="hidden" name="' + input_name + '[estimate_item_companies_attributes][' + nestedIndex + '][_destroy]" value="true">');
              }
              $(this).addClass('hidden');
          });
          sum_cost_price($(this));
          estimateSheetCalcTotal();
          return;
      }
      orderDetailsTable.removeClass('hidden');

      orderDetailsBody.find('tr').each(function() {
          var companyId = $(this).find('input[name*="[company_id]"]').val();
          var nestedIndex = $(this).find('input[name*="[company_id]"]').attr('name').match(/\[(\d+)\]/g)[1].replace(/\D/g, '');

          if (!selectedCompanies.includes(companyId)) {
              if (!$(this).find('input[name*="[_destroy]"]').length) {
                  $(this).append('<input type="hidden" name="' + input_name + '[estimate_item_companies_attributes][' + nestedIndex + '][_destroy]" value="true">');
              }
              $(this).addClass('hidden');
          } else {
              $(this).removeClass('hidden');
          }
      });
      sum_cost_price($(this));

      $(this).find("option:selected").each(function () {
          var companyId = $(this).val();
          var companyName = $(this).text();
          var currentTimeMillis = new Date().getTime();

          if (orderDetailsBody.find(`input[value="${companyId}"]`).length === 0 && companyName !== '') {
              var row = `
                <tr id="company_id_${companyId}">
                  <td>${companyName}</td>
                  <td><input type="hidden" name="${input_name}[estimate_item_companies_attributes][${currentTimeMillis}][company_id]" value="${companyId}">
                    <input type="text" name="${input_name}[estimate_item_companies_attributes][${currentTimeMillis}][quantity]" class="convert-half-width form-control text-right amount-pro est-price-partner input_decimal"></td>
                  <td><input type="text" name="${input_name}[estimate_item_companies_attributes][${currentTimeMillis}][price]" class="convert-half-width form-control text-right est-price-partner price-pro input_decimal"></td>
                </tr>
              `;
              orderDetailsBody.append(row);
              orderDetailsBody.find(`#company_id_${companyId} .input_decimal`).inputFilterx(function(value) {
                  return /^[0-9０-９]{0,8}(([.．。][0-9０-９]{0,2})?)$/.test(value.replace(/,/g, ''));
              }, "整数部分は最大8桁、小数部分は最大2桁です。");
          }
      });

      estimateSheetCalcTotal();
    });
  });

  $(document).on('change', '.est-price-partner', function() {
    sum_cost_price($(this));
  })

  function sum_cost_price(ele) {
    var total_price = 0;
    var has_value = false;
    var total_quantity = 0;
    let $row = ele.closest('.nested-fields');
    const isSegmentCostPrice = $row.find('.js-cost-price').hasClass('segment-cost-price')
    $row.find('tr:not(.hidden)').find('.price-pro').each(function() {
      if($(this).val() != '') {
        has_value = true;
      }
      var value = parseFloat($(this).val().replace(/,/g, '')) || 0;
      var amount = parseFloat($(this).closest('tr').find('.amount-pro').val().replace(/,/g, '')) || 0;
      total_quantity += amount;
      total_price += (value * amount) || 0;
    });

    if (!isSegmentCostPrice){

      if(has_value) {
        var value_string = (total_price/total_quantity).toFixed(2);
        if(isNaN(value_string)) {
          ele.closest('.nested-fields').find('.js-cost-price').val(0);
        } else {
          ele.closest('.nested-fields').find('.js-cost-price').val(Number(value_string).toLocaleString('en-US') || 0);
        }
      } else {
        ele.closest('.nested-fields').find('.js-cost-price').val(0);
      }
    }

  }


  window.estimateSheetCalcTotal = estimateSheetCalcTotal


  //Segmented EST

  $(document).ready(function() {

    $(".js-position").each(function (index) {
      $(this).val(index);
    });


    $(document).on("change", ".level-select", function () {
      let $row = $(this).closest(".nested-fields");
      let level = parseInt($(this).val(), 10);
      let $inputs = $row.find(".input-field, .js-is_freetax");
      if (level === 1 || level === 2 || level === 3) {
        $inputs.prop("disabled", true);
      } else {
        $inputs.prop("disabled", false);
      }
      updatePadding($row)

    });


    $(document).on("change", ".js-product-text", function () {
      let $row = $(this).closest(".nested-fields");
      updatePadding($row)
    });

    function calculateSellingPrice($row) {
      let level = parseInt($row.find(".level-select").val(), 10);
      let totalPrice = 0;
      if ([1, 2, 3].includes(level)) {
          let groupRows = getGroupRows($row);
          let blankItems = groupRows.filter(function () {
          let childRowLevel = parseInt($(this).find(".level-select").val(), 10);
          let isBlankItem = isNaN(childRowLevel);
          let isVisible = $(this).is(":visible");
          if (level === 3 && level != childRowLevel) {
            return isVisible && isBlankItem &&
              $(this).prevAll(".nested-fields").filter(function () {
                let nextLevel = parseInt($(this).find(".level-select").val(), 10)
                  return nextLevel === 3 || nextLevel === 2;
              }).first().is($row) ||
              (
                  $(this).prev(".nested-fields").length > 0 &&
                  parseInt($(this).prev(".nested-fields").find(".level-select").val(), 10) === 3
              );
        }
        else if (level === 2) {
            return isVisible && isBlankItem &&
              $(this).prevAll(".nested-fields:visible").filter(function () {
                return parseInt($(this).find(".level-select").val(), 10) === 2;
            }).first().is($row) ||
              (
                  $(this).prev(".nested-fields").length > 0 &&
                  parseInt($(this).prev(".nested-fields").find(".level-select").val(), 10) === 3
              );
            }else if (level === 1) {
            return isVisible && isBlankItem;
              }
          });
          blankItems.each(function () {
            let priceText = $(this).find(".sell-price").val();
            if (priceText !== undefined && priceText !== null) {
                  let price = parseFloat(priceText.replace(/,/g, "")) || 0;
                  totalPrice += price;
              }
          });
          setTimeout(function(){
            $row.find(".sell-price").val(Math.round(totalPrice).toLocaleString('en-US'));
          }, 100)
      }
    }

    $(".level-select").each(function () {
      let $row = $(this).closest(".nested-fields");
      let currentLevel = $(this).val();
      $row.data("previousLevel", currentLevel || "");
    });

    $(document).on("focus", ".level-select", function () {
      let $row = $(this).closest(".nested-fields");
      let currentLevel = $(this).val();
      $row.data("previousLevel", currentLevel || "");
    });

    $(document).on("change", ".level-select", function () {
      let $row = $(this).closest(".nested-fields");
      let previousLevel = $row.data("previousLevel") || "";
      let newLevel = $(this).val() || "";
      if (!newLevel) {
        $row.find('.sell-price').val(0).trigger("change");
    } else if ((previousLevel && !newLevel) || (!previousLevel && newLevel)) {
        $row.find(".js-amount, .js-price, .js-cost-price").val("");
        $row.find(".js-is_freetax").prop("checked", false);
    }
      $row.data("previousLevel", newLevel);
    });

    window.updateAllPrices = function() {
      $($(".nested-fields:visible").get().reverse()).each(function () {
        calculateSellingPrice($(this));
      });
    }

    $(document).on("change input", ".level-select, .js-amount, .js-price", function () {
      updateAllPrices();
    });
    updateAllPrices();

  });

  function getGroupRows($row) {
    let groupRows = [];
    let currentRow = $row;
    let level = parseInt($row.find('.level-select').val(), 10);

    while (currentRow.next().length > 0) {
        let nextRow = currentRow.next();

        if (!nextRow.is(':visible')) {
            currentRow = nextRow;
            continue;
        }

        let nextLevel = parseInt(nextRow.find(".level-select").val(), 10);

        if ([3, 2].includes(level) && level === nextLevel) break;
        if (!isNaN(nextLevel) && nextLevel === 1) break;

        groupRows.push(nextRow);
        currentRow = nextRow;
    }

    return $(groupRows);
  }


  function updatePadding($row) {
    let level = parseInt($row.find(".level-select").val(), 10);
    let $productText = $row.find('.js-product-text')
    let $parentFiled = $row.find('.parent-fields')
    if (level === 1) {
      $productText.css("text-indent", "0px");
      $parentFiled.css('background-color', '#608ED7');
    }
    else if (level === 2) {
      $productText.css("text-indent", "10px");
      $parentFiled.css('background-color', '#A1D1EE');
    } else if (level === 3) {
      $productText.css("text-indent", "20px");
      $parentFiled.css('background-color', '#D2E5F9');

    } else {
      $parentFiled.css('background-color', '#fff');
      let $parentRow = $row.prevAll(".nested-fields").filter(function () {
        let parentLevel = parseInt($(this).find(".level-select").val(), 10);
        return !isNaN(parentLevel);
      }).first();

      if ($parentRow.length) {
        let parentPadding = parseInt($parentRow.find(".js-product-text").css("text-indent"), 10);
        $productText.css("text-indent", (parentPadding + 10) + "px");
      } else {
        $productText.css("text-indent", "0px");

      }
    }
  }


  $(document).on("click", ".js-add-estimate-item-top", function () {
    setTimeout(function () {
      $(".nested-fields").each(function (index) {
        $(this).find(".js-position").val(index);
      });
    }, 100);
  });


  $(document).on("click", ".js-add-estimate-item-bottom", function () {
    setTimeout(function () {
      let lastPosition = Math.max(...$(".js-position").map(function () {
        return parseInt($(this).val()) || 0;
      }).get());

      $(".nested-fields").last().find(".js-position").val(lastPosition + 1);
    }, 100);
  });


  //Disable checkbox est-checked-ordered

  $(document).on('change', '.est-checked-ordered', function() {
    let isChecked = $(this).prop('checked');
    let $row = $(this).closest('.nested-fields');
    let level = $row.find('.level-select').val();
    let groupRows = getGroupCheckbox($row);

    if (level == 1) {
      toggleCheckboxForGroup(groupRows, $row, isChecked);
    } else if (level == 2 || level == 3 || level == '' ) {
        let tempLevel = (level == '') ? processTempLevelForBlank($row) : level;
        processCheckboxOrder(groupRows, $row, tempLevel, isChecked);
    }
  });

  //Disabled/enabled with select level
  $(document).on('change', '.level-select', function() {
    let $row = $(this).closest('.nested-fields');
    let newLevel = $(this).val();
    let isChecked = $row.find('.est-checked-ordered').prop('checked');
    let groupRows = getGroupCheckbox($row);
    if (newLevel == 1) {
        let $parentRow = findParentLevel1Row($row);
        if ($parentRow.length) {
            $parentRow.find('.est-checked-ordered').prop('disabled', false);
        }
        toggleCheckboxForChangeLevel(groupRows, $row, isChecked);
    } else {
        let tempLevel = newLevel || processTempLevelForBlank($row);
        processCheckboxOrder(groupRows, $row, tempLevel, isChecked);
    }
  });

  function findParentLevel1Row($row) {
    return $row.prevAll('.nested-fields').filter(function() {
        return $(this).find('.level-select').val() == 1;
    }).first();
  }

  //Apply for CHeckbox ordered level 1
  function toggleCheckboxForGroup(groupRows, $row, isChecked) {
    groupRows.each(function () {
      if (!$(this).is($row)) {
        $(this).find('.est-checked-ordered').prop('disabled', isChecked);
        $(this).find('.js-is-disabled-order').val(isChecked);
        $(this).find('.est-checked-ordered').prop('checked', false)
      }
    });
  }

  function toggleCheckboxForChangeLevel(groupRows, $row, isChecked) {
    groupRows.each(function () {
      let $checkbox =  $(this).find('.est-checked-ordered')
      let $disabledOrderField = $(this).find('.js-is-disabled-order')
      if ($(this).is($row)){
        $checkbox.prop('disabled', false);
        $disabledOrderField.val(false);
      }else{
        $checkbox.prop('disabled', isChecked);
        $checkbox.prop('checked', false)
        $disabledOrderField.val(isChecked);
      };

    });
  }


  //Apply for CHeckbox ordered - LEVEL 2,3,''

  function processCheckboxOrder(groupRows, $row, level, isChecked) {
    groupRows.each(function () {
      if ($(this).is($row)) return;
      let $currentRow = $(this);
      let currentLevel = $currentRow.find('.level-select').val()
      let tempLevel = (currentLevel == '') ? processTempLevelForBlank($currentRow) : currentLevel;

      let parentLevel = level - 1;

      let isSameLevelChecked = checkLevelItems($row, level, 'same');
      let isFinalChecked = isChecked || (isSameLevelChecked && !isChecked);
      if (tempLevel != level) {
          $currentRow.find('.est-checked-ordered').prop('disabled', isFinalChecked);
          $currentRow.find('.js-is-disabled-order').val(isFinalChecked);
          $currentRow.find('.est-checked-ordered').each(function(){
            if ($(this).prop('checked')) {
              $(this).prop('checked', false)
              resetPartners($(this).closest('.nested-fields'))
            }
          });
          if (tempLevel == parentLevel ) {
            getItemChildrenWithLevel($currentRow).each(enableCheckbox);
          }
      }else{
        $currentRow.find('.est-checked-ordered').prop('disabled', false);
        $currentRow.find('.js-is-disabled-order').val(false);
      }
    });
  }

  function processTempLevelForBlank($row) {
    let tempLevel = '';
    $row.prevAll('.nested-fields').each(function () {
        let level = $(this).find('.level-select').val();
        if (level != '') {
            tempLevel = parseInt(level, 10) + 1;
            return false;
        }
    });

    return tempLevel;
  }

  function enableCheckbox() {
    let $checkbox = $(this).find('.est-checked-ordered');
    let isDisabledOrderd = $(this).find('.js-is-disabled-order')

    setTimeout(() => {
      $checkbox.prop('disabled', false).removeAttr('disabled');
      isDisabledOrderd.val(false);
    }, 200);
  }

  function checkLevelItems($row, level, type = 'same') {
    let groupRows = getGroupCheckbox($row);
    let result = [];

    groupRows.each(function () {
        let $currentRow = $(this);
        if ($currentRow.is($row)) return;

        let currentLevel = $currentRow.find('.level-select').val();
        let isChecked = $currentRow.find('.est-checked-ordered').prop('checked');
        let tempLevel = (currentLevel === '') ? processTempLevelForBlank($currentRow) : parseInt(currentLevel, 10);

        if (isChecked) {
            if (type === 'same' && level == tempLevel) {
                result.push($currentRow);
            } else if (type === 'children' && level < tempLevel) {
                result.push($currentRow);
            } else if (type === 'parent' && level > tempLevel){
              result.push($currentRow);
            }
        }
    });

    return result.length > 0;
  }

  function getItemChildrenWithLevel($row){
    let itemChildren = [];
    $row.nextAll('.nested-fields').each(function () {
      let itemLevel = $(this).find('.level-select').val()
      if(itemLevel != '') return false;
      itemChildren.push($(this));
    });

    return $(itemChildren);
  }

  function getGroupCheckbox($row) {
    let groupRows = [$row];
    let rowLevel = parseInt($row.find(".level-select").val(), 10)

    if (rowLevel !== 1) {
      $row.prevAll(".nested-fields:visible").each(function () {
          let level = parseInt($(this).find(".level-select").val(), 10);
          groupRows.unshift($(this));
          if (level === 1) return false;
      });
    }
    $row.nextAll(".nested-fields:visible").each(function () {
        let level = parseInt($(this).find(".level-select").val(), 10);

        if (level === 1) return false;

        groupRows.push($(this));
    });

    return $(groupRows);
  }


  $(document).on("click", ".btn-add-est-item", function () {
    let $currentRow = $(this).closest(".nested-fields");
    addNewNestedField($currentRow)
  });

  $(document).on('change', '.est-checked-ordered', function(){
    let $row = $(this).closest(".nested-fields");
    let isChecked = $(this).prop('checked');
    toggleOrderedContainer(isChecked, $row)
  });

  function toggleOrderedContainer(isChecked, $row) {
   if(isChecked){
      $row.find(".ordered-container").removeClass("hidden");
    } else {
      $row.find(".ordered-container").addClass("hidden");
      // Clear company selection when unchecking order presence
      var $companySelect = $row.find(".estimate-sheet-company-id");
      if ($companySelect.length > 0) {
        $companySelect.val([]).trigger('change');
      }
    }
  }


  function addNewNestedField($currentRow){
    let currentTime = Date.now();
    $currentRow.find("select.select2").select2("destroy");

    let maxId = 0;
    $(".nested-fields").each(function () {
        let id = $(this).attr("id").match(/\d+$/);
        if (id && parseInt(id[0]) > maxId) {
            maxId = parseInt(id[0]);
        }
    });

    let newId = "estimate-item-" + (maxId + 1);

    let $newRow = $currentRow.clone(true);

    $newRow.attr("id", newId);
    $newRow.find(".js-is_freetax, .est-checked-ordered").prop("checked", false);
    $newRow.find(".input-field").prop("disabled", false);
    $newRow.find(".level-select, .js-amount, .js-unit, .js-price, .js-product-text").not(".js-sell_price").val("");
    $newRow.find(".js-sell_price, .js-purchase-amount").val(0);
    $newRow.find(".ordered-container").addClass("hidden");
    $newRow.find(".parent-fields").css('background-color', '#fff');
    $newRow.find("select.select2").each(function () {
      $(this).removeAttr("data-select2-id");
      $(this).removeAttr("aria-hidden");
      let newId = $(this).attr("id") + "_" + currentTime;
      $(this).attr("id", newId);
    });
    $newRow.find("select.select2").val([]).trigger("change");
    $newRow.find('.order-details-body').empty();
    $newRow.find("input, select").each(function () {
      let timestamp = currentTime;
      let name = $(this).attr("name");
      let id = $(this).attr("id");

      if (name) {
          name = name.replace(/\[estimate_items_attributes\]\[\d+\]/, "[estimate_items_attributes][" + timestamp + "]");
          $(this).attr("name", name);
      }

      if (id) {
        let newId = id.replace(/\d+/, timestamp);
        $(this).attr("id", newId);
        let labelFor = $newRow.find("label[for='" + id + "']");
        if (labelFor.length) {
            labelFor.attr("for", newId);
        }
    }
    });

    $currentRow.after($newRow);

    handleEstCheckedOrdered($currentRow, $newRow)

    $(".nested-fields").each(function (index) {

      $(this).find(".js-position").val(index);
    });
    $("select.select2").select2({theme: "bootstrap", placeholder: "選択してください"});

    return $newRow;
  }

  function handleEstCheckedOrdered($currentRow, $newRow) {
    const $currentCheckbox = $currentRow.find('.est-checked-ordered');
    const currentLevel = $currentRow.find('.level-select').val();
    const newLevel = $newRow.find('.level-select').val();
    const isDisabled = $currentCheckbox.prop('disabled');
    const isChecked = $currentCheckbox.prop('checked');
    const $newCheckbox = $newRow.find('.est-checked-ordered');
    let tempLevel = (newLevel == '') ? processTempLevelForBlank($newRow) : newLevel;

    if (currentLevel) {
      const disableNew = isChecked || checkLevelItems($currentRow, currentLevel, 'parent') || checkLevelItems($newRow, tempLevel, 'children');
      $newCheckbox.prop('disabled', disableNew);
    } else {
      $newCheckbox.prop('disabled', isDisabled);
    }
  }

  function resetPartners($row) {
    $row.find('.js-purchase-amount').val(0);
    $row.find('.ordered-container').addClass('hidden');
    estimateSheetCalcTotal();
  }

  $(document).on('cocoon:after-insert', function(event, insertedItem) {
    const $newRow = $(insertedItem);
    const newTempLevel = processTempLevelForBlank($newRow);

    let isParentChecked = checkLevelItems($newRow, newTempLevel, 'parent');

    $newRow.find('.est-checked-ordered').prop('disabled', isParentChecked)
    $newRow.find('.js-is-disabled-order').val(isParentChecked)
  });

  $('.select-search-product').on('change', function() {
    const productTypeId = $(this).val();
    const $categorySelect = $('.select-search-category');
    const currentCategoryValue = $categorySelect.val();
    const estimateType = $('.estimate-type').val();
    const projectType = $('.project-type').val();

    $.ajax({
      url: `/product_types/object_lease_types`,
      method: 'GET',
      data: {
        id: productTypeId,
        estimate_type: estimateType,
        project_type: projectType
      },
      success: function(data) {
        let options = '<option value=""></option>';
        let exists = false;

        data.forEach(function(item) {
          options += `<option value="${item.id}">${item.name}</option>`;
          if (item.id == currentCategoryValue) {
            exists = true;
          }
        });

        $categorySelect.html(options);

        if (exists) {
          $categorySelect.val(currentCategoryValue); // Set lại nếu tồn tại
        }
      }
    });
  });

  $('.select-search-category').on('change', function() {
    const objectLeaseTypeId = $(this).val();
    const $productSelect = $('.select-search-product');
    const currentProductValue = $productSelect.val();
    const estimateType = $('.estimate-type').val();
    const projectType = $('.project-type').val();
    $.ajax({
      url: `/object_lease_types/product_types`,
      method: 'GET',
      data: {
        id: objectLeaseTypeId,
        estimate_type: estimateType,
        project_type: projectType
      },
      success: function(data) {
        let options = '<option value=""></option>';
        let exists = false;

        data.forEach(function(item) {
          options += `<option value="${item.id}">${item.name}</option>`;
          if (item.id == currentProductValue) {
            exists = true;
          }
        });

        $productSelect.html(options);

        if (exists) {
          $productSelect.val(currentProductValue);
        }
      }
    });
  });

  function clearFormGroupError($field) {
    const $group = $field.closest('.form-group');
    $group.removeClass('has-error short-text').css('padding-top', '');
    $group.find('.help-block').remove();
    $field.closest('.nested-fields').find('.select2-selection--single').removeClass('has-error');
  }

  function validatePriceField($field) {
    const minPrice = parseFloat($field.data('product-price-min'));
    const newPrice = parseFloat(($field.val() || '').replaceAll(',', ''));
    const productName = $field.data('product-name') || '';
    const $group = $field.closest('.form-group');

    if (Number.isFinite(minPrice) && Number.isFinite(newPrice) && newPrice < minPrice) {
      $group.css('padding-top', '20px').addClass('short-text has-error');
      $group.find('.help-block').remove();
      $group.append(
        '<span class="help-block" data-bs-toggle="tooltip" data-bs-placement="top" title="' +
        productName + 'の単価は、マスタの最低販売単価より高く入力してください。">' +
        productName + 'の単価は、マスタの最低販売単価より高く入力してください。</span>'
      );
    } else {
      $group.css('padding-top', '').removeClass('short-text has-error');
      $group.find('.help-block').remove();
    }
  }

  function checkErrors() {
    const hasVisibleErrors = $('.form-estimate-sheet .form-group.has-error').filter(function () {
      const $group = $(this);
      if (!$group.is(':visible')) return false;
      const $nested = $group.closest('.nested-fields');
      return $nested.length === 0 || $nested.is(':visible');
    }).length > 0;

    $('.form-estimate-sheet .btn-save').prop('disabled', hasVisibleErrors);
  }

  $(document).on('input change', '.form-estimate-sheet .js-price', function() {
    validatePriceField($(this));
    checkErrors();
  });

  $(document).on('input change', '.form-estimate-sheet #template-name', function() {
    if ($(this).val().trim()) {
      clearFormGroupError($(this));
    }
    checkErrors();
  });

  $(document).on('input change', '.form-estimate-sheet .product-label', function() {
    if ($(this).val().trim()) {
      clearFormGroupError($(this));
    }
    checkErrors();
  });

  $(document).on('change', '.form-estimate-sheet .js-product-id', function() {
    clearFormGroupError($(this));
    checkErrors();
  });

  $(document).on('change', '.form-estimate-sheet .level-select', function() {
    const $row = $(this).closest('.nested-fields');
    if ($(this).val() !== '') {
      clearFormGroupError($row.find('.js-product-id'));
    }
    checkErrors();
  });

  $(document).on('click', '.js-btn-ok', function() {
    checkErrors();
  });

  if ($('.form-estimate-sheet').length) {
    $('.form-estimate-sheet .js-price').each(function() {
      validatePriceField($(this));
    });
    checkErrors();
  }
});
